
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import TransactionProgress from '@/components/TransactionProgress';
import { Users, User } from 'lucide-react';


const Processing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data passed from the confirm page
  const amount = location.state?.amount || '';
  const destinationAddress = location.state?.destinationAddress || '';
  const multiDestinations = location.state?.multiDestinations || [];
  const isMulti = location.state?.isMulti || false;
  
  useEffect(() => {
    console.log(`amount::`, amount);
    console.log(`destinationAddress::`, destinationAddress);
    console.log(`multiDestinations::`, multiDestinations);
    console.log(`isMulti::`, isMulti);
    console.log(`isMulti -- >::`, !amount || (!isMulti && !destinationAddress) || (isMulti && multiDestinations.length === 0));
    // If no data was passed, redirect to home
    if (!amount || (!isMulti && !destinationAddress) || (isMulti && multiDestinations.length === 0)) {
      navigate('/');
    }
  }, [amount, destinationAddress, multiDestinations, isMulti, navigate]);
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-2xl glass-panel p-8 relative z-10 overflow-hidden">
          <div className="absolute inset-0 whirlpool-bg opacity-40 -z-10"></div>
          
          <div className="mb-8 text-center">
            <div className="flex justify-center items-center mb-4">
              <div className="flex justify-center items-center w-12 h-12">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="url(#paint0_linear)" strokeWidth="2"/>
                  <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" stroke="url(#paint1_linear)" strokeWidth="2"/>
                  <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="url(#paint2_linear)"/>
                  <defs>
                    <linearGradient id="paint0_linear" x1="2" y1="12" x2="22" y2="12" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#22D3EE"/>
                      <stop offset="1" stopColor="#0EA5E9"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear" x1="6" y1="12" x2="18" y2="12" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#22D3EE"/>
                      <stop offset="1" stopColor="#0EA5E9"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear" x1="10" y1="12" x2="14" y2="12" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#22D3EE"/>
                      <stop offset="1" stopColor="#0EA5E9"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-whirlpool-cyan to-whirlpool-blue bg-clip-text text-transparent">
              Processing Transaction
            </h1>
            <p className="text-muted-foreground mt-3 text-lg">
              Your {amount} SOL is being anonymized through the WhirlPool
            </p>
            
            <div className="mt-3 flex justify-center">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/5 rounded-full text-sm">
                {isMulti ? (
                  <>
                    <Users className="h-3.5 w-3.5 text-whirlpool-cyan" />
                    <span className="text-whirlpool-light">
                      {multiDestinations.length} destination{multiDestinations.length > 1 ? 's' : ''}
                    </span>
                  </>
                ) : (
                  <>
                    <User className="h-3.5 w-3.5 text-whirlpool-cyan" />
                    <span className="text-whirlpool-light">
                      Single destination
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
          
          <TransactionProgress isMulti={isMulti} destinationCount={isMulti ? multiDestinations.length : 1} data={location.state} />
          
          <div className="mt-10 text-center">
            <div className="inline-block px-6 py-3 bg-gradient-to-r from-whirlpool-cyan/20 to-whirlpool-blue/20 rounded-lg border border-whirlpool-cyan/30 backdrop-blur-sm">
              <p className="text-sm text-whirlpool-cyan font-medium">
                Complete anonymization takes 2-5 minutes
              </p>
              <p className="mt-1 text-xs text-white/70">
                Do not close this page until processing is complete
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Processing;
